module.exports = __webpack_public_path__ + "img/60.5bd87097.jpg";